var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isLeaflet    = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isLeaflet = true;
  }
}

const Leaflet = (
  await import(`${isLeaflet ? `https://ga.jspm.io/npm:leaflet@1.9.4/dist/leaflet-src.js` : `./leaflet`}`)
).default

$(document).ready(function() {
  // Init modal
  const modalLocation = document.getElementById('modal-merchant-loc-detail');

  if (modalLocation) {
    // Map init
    const locDetail = new bootstrap.Modal(modalLocation);

    var fetchDataUrl   = modalLocation.dataset.fetchMerchantsUrl
    var latLong        = [4.2105, 101.9758]
    var list_merchants = $('.list-merchants')
    list_merchants = list_merchants.map(function(_idx, el){
      if (el.dataset.branchLatitude !== '' && el.dataset.branchLongitude !== '') {
        return [[parseFloat(el.dataset.merchantLatitude), parseFloat(el.dataset.merchantLongitude)]] 
      }
    })

    if (list_merchants.length >= 1) {
      latLong = list_merchants[0]
    }

    let mapOptions = {
      center: latLong,
      zoom: 10,
    }
  
    const mapEl = document.querySelector('#map')
    if (!mapEl) {
      return null
    }
  
    let map = Leaflet.map('map', mapOptions)
  
    let layer = new Leaflet.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
  
    map.addLayer(layer)
    map.zoomControl.remove()

    // Update map center to current user loc
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        map.panTo(new Leaflet.LatLng(position.coords.latitude, position.coords.longitude));
      });
    }

    // Marker init
    let iconOptions = {
      iconUrl: '/assets/liquids/assets/icons/pin-dark.svg',
      iconSize: [42, 42],
      iconAnchor: [16, 32],
    }
  
    var tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
    tabLinks.forEach(function(tabLink) {
      tabLink.addEventListener('shown.bs.tab', function (e) {
        map.invalidateSize();
      });
    });
  
    $.ajax({
      url: fetchDataUrl,
      method: 'get',
      contentType: 'application/json',
      data: {},
      dataType: 'json',
      success: function(res) {
        res['merchants'].forEach(merchant => {
          if (merchant.latitude && merchant.longitude) {
            let marker = Leaflet.marker([merchant.latitude, merchant.longitude], { icon: Leaflet.icon(iconOptions), title: merchant.merchant_name }).addTo(map)
            marker.on('click', function () {
              var merchant_name    = merchant.merchant_name
              var merchant_address = merchant.merchant_address
              var whatsapp_link = merchant.whatsapp_link || 'javascript:;'
              var contact_link = merchant.merchant_contact ? `tel:${merchant.merchant_contact}` : 'javascript:;'
              $('#merchant-name').text(merchant_name)
              $('#merchant-address').text(merchant_address)
              $('#link-view-detail').attr('href', `/user/merchant/${merchant.merchant_id}`)
              $('#popup-map-direction').attr('data-merchant-id', merchant.merchant_id)
              $('#merchant-thumbnail').attr('src', merchant.thumbnail)
              $('#whatsapp_link').attr('href', whatsapp_link)
              $('#contact_link').attr('href', contact_link)
              if (merchant['open?']) {
                $('#open-status').html('Open')
                $('#open-status').addClass('badge-success-overlay')
              } else {
                $('#open-status').html('Closed')
                $('#open-status').addClass('badge-danger-overlay')
              }
              locDetail.show()
            })
          }
        })
      },
      error: (err, status) => {
        console.log(err.responseJSON.error)
      }
    });
  }
})
